import { useState, useCallback, useEffect } from 'react';
import companyServices from 'services/company.services';

export default function useGetCompanyMeterConnection() {
  const [loading, setLoading] = useState(false);
  const [listCompanyMeterConnection, setListCompanyMeterConnection] = useState([]);

  const getCompanyMeterConnection = useCallback(async () => {
    try {
      setLoading(true);
      const data = await companyServices.listCompanyMeterConnection();
      setListCompanyMeterConnection(data.items);
    } catch (err) {
      console.error(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    getCompanyMeterConnection();
  }, []);

  return {
    loading,
    listCompanyMeterConnection,
    getCompanyMeterConnection
  };
}
